import { rem } from 'polished';
import styled from 'styled-components';
import { IColors } from '../../interfaces/Conference';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(40)} 0 ${rem(15)} 0;
`;

export const Title = styled.span<{ colors: IColors }>`
    padding-bottom: ${rem(30)};
    display: inline-block;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
    position: relative;
    color: ${(props) => props.colors?.colorTitle};
`;

export const TitleSymbol = styled.span<{ colors: IColors }>`
    position: absolute;
    width: ${rem(40)};
    height: ${rem(5)};
    background: ${(props) => props.colors?.colorLine};
    left: 0;
    bottom: ${rem(15)};
`;

export const Gallery = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${rem(30)};
`;

export const ImageWrapper = styled.div`
    padding: ${rem(20)} 0;
    display: flex !important;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    height: ${rem(300)};
`;

export const GalleryImage = styled.img`
    width: auto;
    height: 100%;
`;
